import { createContext } from 'react';
import type { VtkAnnotation, SegmentPointPositionTuple } from '../types';

// @ts-expect-error [EN-10263] - TS2322 - Type 'Context<{ updateAnnotation: null; updateAnnotationBatch: null; deleteAnnotation: null; updateAnnotationSegments: null; }>' is not assignable to type 'Context<{ updateAnnotation: (id: string) => (annotation: Partial<VtkAnnotation>) => Promise<undefined> | null | undefined; updateAnnotationBatch: ((filterer: (annotation: VtkAnnotation) => boolean, updater: (annotation: VtkAnnotation) => Partial<...>) => void | Promise<...>) | ... 1 more ... | undefined; updateAnnot...'.
export const AnnotationMutationsContext: React.Context<{
  updateAnnotation: (
    id: string
  ) => (annotation: Partial<VtkAnnotation>) => Nullable<Promise<undefined>>;
  updateAnnotationBatch: Nullable<
    (
      filterer: (annotation: VtkAnnotation) => boolean,
      updater: (annotation: VtkAnnotation) => Partial<VtkAnnotation>
    ) => Promise<void> | void
  >;
  updateAnnotationSegments: (
    arg1: string,
    arg2?: Nullable<boolean>
  ) => (arg1: Array<SegmentPointPositionTuple>) => Nullable<Promise<unknown>>;
  deleteAnnotation: (arg1: string) => Nullable<Promise<unknown>>;
}> = createContext({
  updateAnnotation: null,
  updateAnnotationBatch: null,
  deleteAnnotation: null,
  updateAnnotationSegments: null,
});
